import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row mt-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Name")
], -1)
const _hoisted_4 = { class: "col-10" }
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Subject")
], -1)
const _hoisted_8 = { class: "col-10" }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = { class: "row mt-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Body")
], -1)
const _hoisted_12 = { class: "row mt-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Type")
], -1)
const _hoisted_14 = { class: "col-10" }
const _hoisted_15 = { class: "row mt-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "mb-0",
    for: "isAssignable"
  }, "Is Assignable")
], -1)
const _hoisted_17 = { class: "col-10" }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-12 d-flex justify-content-end mt-3" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick", "disabled"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "w-100"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Name ")
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Type ")
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Is Assignable ")
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Subject ")
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Body ")
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Date Created ")
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "col-2" }
const _hoisted_39 = { class: "col-2" }
const _hoisted_40 = { class: "col-2" }
const _hoisted_41 = { class: "col-4" }
const _hoisted_42 = { class: "col-4 m-0" }
const _hoisted_43 = {
  key: 0,
  class: "border bg-gray-50"
}
const _hoisted_44 = { class: "col-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ckeditor = _resolveComponent("ckeditor")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_SortIcon = _resolveComponent("SortIcon")!
  const _component_RenderHtml = _resolveComponent("RenderHtml")!
  const _component_ListView = _resolveComponent("ListView")!

  return (_openBlock(), _createBlock(_component_ListView, {
    name: _ctx.name,
    actions: _ctx.emailTemplatesActions,
    resolveState: _ctx.resolveState,
    createEmptyItem: _ctx.createEmptyItem
  }, {
    edit: _withCtx(({ selectedItem, addItem, updateItem, deleteItem }) => [
      selectedItem
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  required: "",
                  "onUpdate:modelValue": ($event: any) => ((selectedItem.name) = $event)
                }, null, 8, _hoisted_5), [
                  [_vModelText, selectedItem.name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  required: "",
                  "onUpdate:modelValue": ($event: any) => ((selectedItem.subject) = $event)
                }, null, 8, _hoisted_9), [
                  [_vModelText, selectedItem.subject]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              (_openBlock(), _createElementBlock("div", {
                class: "col-10",
                key: _ctx.kind
              }, [
                (_ctx.editorConfig)
                  ? (_openBlock(), _createBlock(_component_ckeditor, {
                      key: 0,
                      onReady: _ctx.editorReady,
                      editor: _ctx.editorType,
                      config: _ctx.editorConfig,
                      modelValue: selectedItem.body,
                      "onUpdate:modelValue": ($event: any) => ((selectedItem.body) = $event)
                    }, null, 8, ["onReady", "editor", "config", "modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true)
              ]))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_AutoComplete, {
                  modelValue: _ctx.resolveKind(selectedItem.kind),
                  onItemSelect: ($event: any) => (_ctx.kindSelected(selectedItem, $event.value)),
                  suggestions: _ctx.emailTemplateKinds,
                  multiple: false,
                  autoHighlight: false,
                  delay: 0,
                  forceSelection: true,
                  dropdown: true,
                  completeOnFocus: true,
                  onComplete: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchKinds($event.query))),
                  field: "friendlyName"
                }, null, 8, ["modelValue", "onItemSelect", "suggestions"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "isAssignable",
                  "onUpdate:modelValue": ($event: any) => ((selectedItem.isAssignable) = $event)
                }, null, 8, _hoisted_18), [
                  [_vModelCheckbox, selectedItem.isAssignable]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                (selectedItem?.id != null)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-danger mr-1",
                      onClick: _withModifiers(($event: any) => (deleteItem(selectedItem.name)), ["prevent"])
                    }, " Delete " + _toDisplayString(_ctx.name), 9, _hoisted_21))
                  : _createCommentVNode("", true),
                (selectedItem?.id == null)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-primary",
                      onClick: _withModifiers(addItem, ["prevent"]),
                      disabled: selectedItem?.name && selectedItem.name.length === 0
                    }, " Add " + _toDisplayString(_ctx.name), 9, _hoisted_22))
                  : _createCommentVNode("", true),
                (selectedItem?.id != null)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "btn btn-primary",
                      onClick: _withModifiers(updateItem, ["prevent"])
                    }, " Update " + _toDisplayString(_ctx.name), 9, _hoisted_23))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    list: _withCtx(({
        selectedItem,
        items,
        setSelected,
        setSort,
        sortBy,
        sortByDescending
      }) => [
      (items.length > 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_24, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  class: "cursor-pointer",
                  onClick: _withModifiers(($event: any) => (setSort('Name')), ["prevent"])
                }, [
                  _hoisted_26,
                  _createVNode(_component_SortIcon, {
                    sortBy: sortBy,
                    sortByDescending: sortByDescending,
                    field: "Name"
                  }, null, 8, ["sortBy", "sortByDescending"])
                ], 8, _hoisted_25),
                _createElementVNode("th", {
                  class: "cursor-pointer",
                  onClick: _withModifiers(($event: any) => (setSort('Type')), ["prevent"])
                }, [
                  _hoisted_28,
                  _createVNode(_component_SortIcon, {
                    sortBy: sortBy,
                    sortByDescending: sortByDescending,
                    field: "Type"
                  }, null, 8, ["sortBy", "sortByDescending"])
                ], 8, _hoisted_27),
                _createElementVNode("th", {
                  class: "cursor-pointer",
                  onClick: _withModifiers(($event: any) => (setSort('IsAssignable')), ["prevent"])
                }, [
                  _hoisted_30,
                  _createVNode(_component_SortIcon, {
                    sortBy: sortBy,
                    sortByDescending: sortByDescending,
                    field: "IsAssignable"
                  }, null, 8, ["sortBy", "sortByDescending"])
                ], 8, _hoisted_29),
                _createElementVNode("th", {
                  class: "cursor-pointer",
                  onClick: _withModifiers(($event: any) => (setSort('Subject')), ["prevent"])
                }, [
                  _hoisted_32,
                  _createVNode(_component_SortIcon, {
                    sortBy: sortBy,
                    sortByDescending: sortByDescending,
                    field: "Subject"
                  }, null, 8, ["sortBy", "sortByDescending"])
                ], 8, _hoisted_31),
                _createElementVNode("th", {
                  class: "cursor-pointer",
                  onClick: _withModifiers(($event: any) => (setSort('Body')), ["prevent"])
                }, [
                  _hoisted_34,
                  _createVNode(_component_SortIcon, {
                    sortBy: sortBy,
                    sortByDescending: sortByDescending,
                    field: "Body"
                  }, null, 8, ["sortBy", "sortByDescending"])
                ], 8, _hoisted_33),
                _createElementVNode("th", {
                  class: "cursor-pointer",
                  onClick: _withModifiers(($event: any) => (setSort('DateCreated')), ["prevent"])
                }, [
                  _hoisted_36,
                  _createVNode(_component_SortIcon, {
                    sortBy: sortBy,
                    sortByDescending: sortByDescending,
                    field: "DateCreated"
                  }, null, 8, ["sortBy", "sortByDescending"])
                ], 8, _hoisted_35)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cast(items), (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id,
                  class: _normalizeClass(item.id == selectedItem?.id ? 'selected-row' : ''),
                  onClick: _withModifiers(($event: any) => (_ctx.cleanSelected(item) && setSelected(item)), ["prevent"])
                }, [
                  _createElementVNode("td", _hoisted_38, _toDisplayString(item.name), 1),
                  _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.resolveKindName(item.kind)), 1),
                  _createElementVNode("td", _hoisted_40, _toDisplayString(item.isAssignable ? "Yes" : "No"), 1),
                  _createElementVNode("td", _hoisted_41, _toDisplayString(item.subject), 1),
                  _createElementVNode("td", _hoisted_42, [
                    (!!item.body)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createVNode(_component_RenderHtml, {
                            html: item.body
                          }, null, 8, ["html"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.$filters.dateTime(item.dateCreated)), 1)
                ], 10, _hoisted_37))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["name", "actions", "resolveState", "createEmptyItem"]))
}